import { FormattedMessage } from 'react-intl';
import * as Sentry from '@sentry/browser';

import { Button, ButtonType, ButtonVariant, ExclamationTriangleIcon } from '@jsmdg/yoshi';
import styles from './FragmentError.module.scss';

interface FragmentErrorProps {
    readonly dsn?: string;
    readonly eventId?: string;
}

const FragmentError = ({ dsn, eventId }: FragmentErrorProps) => (
    <div className={styles.fragmentErrorWrapper}>
        <div className={styles.fragmentErrorContent}>
            <FormattedMessage id="FragmentError.headline" defaultMessage="Es tut uns leid!">
                {txt => <h1>{txt}</h1>}
            </FormattedMessage>
            <FormattedMessage
                id="FragmentError.errorMessage"
                defaultMessage="Ein technischer Fehler liegt vor."
            >
                {txt => (
                    <p className={styles.errorMessage}>
                        <ExclamationTriangleIcon className={styles.errorIcon} />
                        {txt}
                    </p>
                )}
            </FormattedMessage>
            <FormattedMessage
                id="FragmentError.callToHelp"
                defaultMessage="Bitte hilf uns, damit wir das Problem schnellstmöglich beheben können!"
            >
                {txt => <p>{txt}</p>}
            </FormattedMessage>

            <FormattedMessage id="FragmentError.reportButtonText" defaultMessage="Fehler melden">
                {txt => (
                    <Button
                        variant={ButtonVariant.Outlined}
                        type={ButtonType.Submit}
                        className={styles.reportButton}
                        onClick={() => Sentry.showReportDialog({ eventId, dsn })}
                    >
                        {txt}
                    </Button>
                )}
            </FormattedMessage>
        </div>
    </div>
);

export { FragmentError };
